import { ButtonProps } from '@mui/material';
import { ForwardedRef, forwardRef } from 'react';

import { HBCircularProgressBtn } from '../HBCircularProgressBtn/HBCircularProgressBtn';
import { HBButtonRootStyle } from './HBButton.styles';

export interface HBButtonProps extends Omit<ButtonProps, 'ref'> {
  loading?: boolean;
  dataTestId?: string;
}

export const HBButton = forwardRef(
  <T extends HTMLButtonElement>(
    { children, loading, variant = 'contained', color = 'primary', ...props }: HBButtonProps,
    ref: ForwardedRef<T>,
  ) => {
    return (
      <HBButtonRootStyle
        {...props}
        ref={ref}
        variant={variant}
        color={color}
        disabled={props.disabled || loading}
      >
        {loading ? <HBCircularProgressBtn size={20} /> : children}
      </HBButtonRootStyle>
    );
  },
);

HBButton.displayName = 'HBButton';
